import { useMutation } from '@tanstack/react-query';
import type { ReceiptKind } from '@his/shared';
import { get, qs } from '@/lib/api';
import { describeError } from '@/lib/auth';
import { printDocument } from '@/lib/print';
import { useToast } from '@/components/ui/toast';

export interface PrintReceiptRequest {
  kind: ReceiptKind;
  id: string;
  size: 'A4' | 'thermal';
  original?: boolean;
}

export function usePrintReceipt() {
  const toast = useToast();
  return useMutation({
    mutationFn: (request: PrintReceiptRequest) =>
      get<{ html: string }>(
        `/receipts/${request.kind}/${request.id}/print${qs({ size: request.size, copy: request.original ? 'original' : undefined })}`,
      ),
    onSuccess: (doc) => printDocument(doc.html),
    onError: (error) => toast.error('Could not print the receipt', describeError(error)),
  });
}

export function toMinor(text: string): number {
  return Math.round(Number(text || 0) * 100);
}

export function fromMinorInput(minor: number): string {
  return String(minor / 100);
}
